module.exports = __webpack_public_path__ + "static/media/attribute_manaregen.e8dbf52e.png";